import React from 'react';
import { Modal } from '@design-system';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

export const NoCreditModal = ({ setShowModal, isOpen }) => {
  const { t } = useTranslation();
  return (
    <Modal
      showModal={isOpen}
      setShowModal={setShowModal}
      showCancel={false}
      acceptText={t(translations.MODALS.NO_CREDIT_TO_CREATE_DOCUMENT_CLOSE)}
      width="md:w-6/12 xl:w-4/12"
      title={t(translations.MODALS.NO_CREDIT_TO_CREATE_DOCUMENT_TITLE)}>
      <p className="text-center text-paragraph md:text-subtitle">
        {t(translations.MODALS.NO_CREDIT_TO_CREATE_DOCUMENT)}
      </p>
    </Modal>
  );
};
